import {
  getOptimizedImageUrl,
  ImagePresets,
} from "@/lib/utils/supabaseImageTransform";
import { Edit2 } from "lucide-react";
import { memo } from "react";

/**
 * ImageEditPreview - Shows the original image thumbnail for image edit requests
 * Displays when a user initiates an image edit with instructions
 *
 * @param {Object} props
 * @param {string} props.imageUrl - URL of the original image being edited
 * @param {string} props.editPrompt - The editing instruction/prompt
 */
const ImageEditPreview = memo(function ImageEditPreview({
  imageUrl,
  editPrompt,
}) {
  if (!imageUrl) return null;

  return (
    <div className="flex items-start gap-3 p-3 bg-muted/50 rounded-lg border border-border max-w-md mb-3">
      {/* Thumbnail */}
      <div className="relative flex-shrink-0 w-20 h-20 rounded-md overflow-hidden bg-background border border-border">
        <img
          src={getOptimizedImageUrl(imageUrl, ImagePresets.avatar)}
          alt="Image to edit"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-purple-600/10 flex items-center justify-center">
          <Edit2 className="h-5 w-5 text-purple-600" />
        </div>
      </div>

      {/* Edit info */}
      <div className="flex-1 min-w-0 py-1">
        <div className="flex items-center gap-2 mb-1">
          <Edit2 className="h-3.5 w-3.5 text-purple-600" />
          <span className="text-xs font-medium text-purple-600">
            Image Edit Request
          </span>
        </div>
        {editPrompt && (
          <p className="text-xs text-muted-foreground line-clamp-2">
            {editPrompt}
          </p>
        )}
      </div>
    </div>
  );
});

ImageEditPreview.displayName = "ImageEditPreview";

export default ImageEditPreview;
